import { RevenueReportPartnerBranchListPage } from "@/features/revenue-report-partner-branch/pages/RevenueReportPartnerBranchListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/revenue-report-partner-branch/")({
	validateSearch: (search: Record<string, unknown>) => search,
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({
				permissions: ["revenue_report_partner_branch.view"],
			})
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: RevenueReportPartnerBranchListPage,
});
